export default class MissionBriefingEvent {
    constructor(type) {
        this.type = type;
    }
}

MissionBriefingEvent.START = "MissionBriefingEvent.START";
MissionBriefingEvent.FINISH = "MissionBriefingEvent.FINISH";